module.exports = __webpack_public_path__ + "static/media/help.5be6036b.svg";